import Licencia from "./licencia";
import AdminLicenciaActivadaForm from "./licencia-activada-form";

export default class AdminLicenciaLista {

    /**
     *
     * @param {number} props.packId
     * @param {number} props.loteId
     * @param {Array} props.grados
     * @param {Array} props.secciones
     */
    constructor(props) {
        $('#empresa_ids').select2();

        $('.btn-editar').click(function () {
            let id = this.parentNode.dataset.id;
            let formModal = new AdminLicenciaActivadaForm({ grados: props.grados, secciones: props.secciones });
            formModal.editar(id, {
                onSuccess: function () {
                    window.location.reload();
                }
            });
        });

        $('#btn-limpiar').click(function () {
            window.location.href = window.location.origin + window.location.pathname;
        });

        $('#btn-buscar').click(function () {
            window.location.href = window.location.origin + window.location.pathname + '?' + $('#form-buscar').serialize();
        });

        $('.btn-desactivar').click(function () {
            let id = this.parentNode.dataset.id;
            let btn = this;
            btn.disabled = true;
            Licencia.desactivar(id, {
                then: function () {
                    btn.parentNode.querySelector('.btn-activar').classList.remove('d-none');
                    btn.classList.add('d-none');
                },
                fail: function (error) {
                    window.alert(error.response.data.message);
                },
                always: function () {
                    btn.disabled = false;
                }
            });
        });

        $('.btn-activar').click(function () {
            let id = this.parentNode.dataset.id;
            let btn = this;
            btn.disabled = true;
            Licencia.activar(id, {
                then: function () {
                    btn.parentNode.querySelector('.btn-desactivar').classList.remove('d-none');
                    btn.classList.add('d-none');
                },
                fail: function (error) {
                    window.alert(error.response.data.message);
                },
                always: function () {
                    btn.disabled = false;
                }
            });
        });

        $('.btn-enviar-correo').click(function () {
            let id = this.parentNode.dataset.id;
            let respuesta = window.confirm('¿Enviar correo?');
            if (respuesta) {
                let btn = this;
                btn.disabled = true;
                Licencia.enviarCorreo(id, {
                    then: function (response) {
                        window.alert(response.data.message);
                    },
                    fail: function (error) {
                        window.alert(error.response.data.message);
                    },
                    always: function () {
                        btn.disabled = false
                    },
                });
            }
        });

        $('#btn-exportar').click(function () {
            let uri = (props.packId > 0 && props.loteId > 0) ? '/admin/paquetes/' + props.packId + '/lotes-licencias/' + props.loteId + '/licencias-excel?' : '/admin/licencias/excel?';
            window.location.href = window.location.origin + uri + $('#form-buscar').serialize();
        });
    }
}
